import BackTopbar, { TopbarClearfix } from "@elements/BackTopbar"
import ScreenContainer from "./ScreenContainer"
import styled from "@emotion/styled"
import { colors, fontSize, size } from "@styles/theme"
import { PiMapPin } from "react-icons/pi"
import { BackgroundImage } from "@components/auth/landing/LandingElements"

const ContainerInner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const Title = styled.h1`
  display: inline-block;
  font-size: ${size(5)};
  font-weight: 500;
  letter-spacing: 1px;
  line-height: ${size(4)};
  margin: 0;
  padding: ${size(4)} 0 ${size(3)} 0;
  text-align: center;
`

const Tagline = styled.p`
  diasplay: flex;
  align-items: center;
  color: ${colors.success(200)};
  font-size: ${fontSize('sm')};
  line-height: ${size(1)};
`

const Mission = styled.p`
  font-size: ${size(2.5)};
  padding: 0 ${size(3)};
  line-height: ${size(4)};
  color: lightgrey;
  text-align: center;
`

const Section = styled.div`
  padding: ${size(3)} ${size(3)};
  margin-top: ${size(3)};
  width: 100dvw;
`

const SectionTitle = styled.h2`
  font-size: ${size(2.75)};
  font-weight: 500;
  letter-spacing: 0.75px;
  line-height: ${size(3.75)};
  margin: 0;
`

const SectionHr = styled.hr`
  margin: ${size(0.25)} 0 ${size(1)} 0;
  padding: 0;
  border-radius: 100px;
  border: 0;
  height: 2px;
  background-color: grey;
`

const SectionContent = styled.p`
  font-size: ${size(2.5)};
  padding: 0 ${size(2)};
  line-height: ${size(4)};
  border-left: 10px solid ${colors.statusColors.right_now('primary')};
`

const SectionNotes = styled.p`
  font-size: ${size(2.25)};
  padding: 0 ${size(2)};
  line-height: ${size(4)};
`
  
const SectionNotesCard = styled(SectionNotes)`
  background-color: #333333;
  padding: ${size(2)};
  border-radius: 10px;
`

const NearbySocialScreens = styled.div`
  display: flex;
  padding: ${size(7)} 0 0 0;
  gap: ${size(2)};
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
`

const LookingStatusContainer = styled.div`
  width: 100%;
  display: flex;
  alignItems: center;
  padding: ${size(5)} 0 ${size(0)} 0;
`

const Image = styled.img`
  border-radius: 10px;
  border: 1px solid rgba(255,255,255, 0.2);
`

const About = () => {
  return(
    <ScreenContainer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflowY: 'scroll' }}>
      <BackgroundImage src='https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-2-480w.jpeg' />
      <BackTopbar title='About' />
      <ContainerInner>
        <TopbarClearfix />
        <Title>
          MANDRAKE<br />
          <Tagline><PiMapPin style={{ marginTop: -1 }} size={size(1.5)} />&nbsp;<i>Find what you're looking for.</i></Tagline>
        </Title>
        <Mission>
          Mandrake uses social media, maps, and grids, for nearby gay men (LGBTQ+ community) to meet up and socialize.
        </Mission>
        <Section>
          <SectionTitle>
            NEARBY AND SOCIAL FEATURES
          </SectionTitle>
          <SectionHr />
          <SectionContent>
            Use <i>both</i> a map and twitter-style feed to see men near and far.
          </SectionContent>
          <NearbySocialScreens>
            <Image style={{ width: '45%' }} src='https://mandrake-app.b-cdn.net/dev/application/display_elements/map-screen.jpg' />
            <Image style={{ width: '45%' }} src='https://mandrake-app.b-cdn.net/dev/application/display_elements/feed-screen.jpg' />
          </NearbySocialScreens>
          <SectionNotesCard>
            The map shows men near your position in real time, but you can also browse the feed and make posts.
          </SectionNotesCard>
          <NearbySocialScreens>
            <Image style={{ width: '45%' }} src='https://mandrake-app.b-cdn.net/dev/application/display_elements/nearby-profile.jpg' />
            <Image style={{ width: '45%' }} src='https://mandrake-app.b-cdn.net/dev/application/display_elements/social-profile.jpg' />
          </NearbySocialScreens>
          <SectionNotesCard>
            You also get separate nearby <i>and</i> social profiles so you can show different content depending on your preference.
          </SectionNotesCard>
        </Section>
        <Section>
          <SectionTitle>
            SET A LOOKING STATUS
          </SectionTitle>
          <SectionHr />
          <SectionContent>
            The looking status shows men near you what you're looking for <i>at this moment</i> so there's no confusion.
          </SectionContent>
          <LookingStatusContainer>
            <Image style={{ width: '75dvw', margin: 'auto' }} src='https://mandrake-app.b-cdn.net/dev/application/display_elements/looking-status-screen.jpg' />
          </LookingStatusContainer>
          <SectionNotesCard>
            When a status is set, profiles on the map are colored and display the icon for that status.
          </SectionNotesCard>
        </Section>
        <Section>
          <SectionTitle>
            AND MORE . . .
          </SectionTitle>
          <SectionHr />
          <SectionNotes>
            <li><b><i>NO THIRD PARTY ADS</i></b></li>
            <li>Anonymous User Profiles</li>
            <li>Grid Screen Alternative</li>
            <li>Hidden mode</li>
            <li>Instant Messaging</li>
          </SectionNotes>
          <SectionNotes style={{ marginTop: size(5) }}>
            <i>Our subscription <b> is never necessary and will always be reasonable</b></i>.
          </SectionNotes>
          <SectionNotes style={{ margin: `${size(5)} 0 ${size(15)} 0` }}>
            Try us out, and see for yourself ❤️
          </SectionNotes>
        </Section>
      </ContainerInner>
    </ScreenContainer>
  )
}

export default About
